import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HttpModule } from '@angular/http';

// materials
import { RippleGlobalOptions, MAT_RIPPLE_GLOBAL_OPTIONS, MatCheckboxModule } from '@angular/material';

const globalRippleConfig: RippleGlobalOptions = { disabled: true };



// Services
import {
	ServerService, LogService, UserService
	, StorageService, LoaderService, MessageService, HelperService
	, ApplicationService, PromptService, SsoService, CmsService, DiscussionService, ReviewerService, ApplicationDownloadService, DialogService, VoteService, QuestionService, FileService, StepService
} from './services';

import * as local from '../modules/levels/services';

// pipes
import { HasRolePipe, ToLocalDatePipe, UtcToLocalPipe, HasMoreRolePipe, ProfilePipe, RolePipe, ReviewerRolePipe, ReviewerBlockPipe } from './pipes';


import { LastitemDirective } from './directives/lastitem.directive';

// Components
import {
	PaginationComponent,
	LevelComponent,
	LevelsComponent,
	LoaderComponent,
	LoadingComponent,
	MessageComponent,
	TermsComponent,
	PromptComponent,
	MenuComponent,
	TopbannerComponent,
	AssignReviewersComponent,
    TextDialogComponent,
	TextboxDialogComponent
} from './components';

@NgModule({
	imports: [
		CommonModule,
		RouterModule,
		HttpModule,
		MatCheckboxModule
	],
	declarations: [
		MenuComponent,
		LoaderComponent,
		LoadingComponent,
		LastitemDirective,
		PaginationComponent,
		MessageComponent,
		HasRolePipe,
		HasMoreRolePipe,
		ProfilePipe,
		RolePipe,
		ReviewerRolePipe,
		ReviewerBlockPipe,
		ToLocalDatePipe,
		UtcToLocalPipe,
		LevelComponent,
		LevelsComponent,
		TermsComponent,
		TopbannerComponent,
		PromptComponent,
		AssignReviewersComponent,
		TextDialogComponent,
		TextboxDialogComponent
	],
	exports: [
		TopbannerComponent,
		MenuComponent,
		LoaderComponent,
		LoadingComponent,
		LastitemDirective,
		PaginationComponent,
		MessageComponent,
		AssignReviewersComponent,
		TextDialogComponent,
		TextboxDialogComponent,		
		LevelComponent,
		LevelsComponent,
		TermsComponent,
		PromptComponent,
		HasRolePipe,
		ReviewerRolePipe,
		ReviewerBlockPipe,
		HasMoreRolePipe,
		ToLocalDatePipe,
		UtcToLocalPipe,
		ProfilePipe,
		RolePipe
	],
	providers: [
		{ provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: globalRippleConfig }
	]
})
export class ShareModule {
	static forRoot() {   // pattern for adding app-wide services
		return {
			ngModule: ShareModule,
			providers: [
				ServerService,
				LogService,
				UserService,
				StorageService, 
				LoaderService,
				MessageService,
				HelperService,
				ApplicationService,
				PromptService,
				DialogService,
				SsoService,
				CmsService,
				DiscussionService,
				ReviewerService,
				ApplicationDownloadService,
				FileService,
				StepService,
				QuestionService
			],
		};
	}
}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/share.module.ts